import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import TitreAxe from '../components/titre-axe.js'
import SvgCollectif from "../../images/collectif.svg"
import BtnLePalaisMontcalm from '../components/btn-le-palais-montcalm.js'
import BtnSymeon from '../components/btn-symeon.js'
import BtnHenrietteBelley from '../components/btn-henriette-belley.js'
import BtnCapsuleViolons from '../components/btn-capsule-violons.js'
import InfoBox from '../components/info.js'
import GravureViolon from './../../images/II. Violons du Roy (DancingMasterLS (violons).jpg'
import styles from '../components/index.module.css';
import ImageFooter from '../components/image-footer-axe2.js'
import FragAxe2 from '../components/frag-axe2.js'

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'fondations'}}/>
        <SidebarLeft>
          <div style={{width : "100%", height: "740px", display: "flex", flexDirection: "column", justifyContent: "space-between",alignItems: "flex-end", paddingBottom: "1.45rem"}}>
            <div style={{maxWidth: "700px", width: "100%", height: "auto"}}>
                <div className='metadata--wrapper'>
                    <img src={GravureViolon} alt=""/>
                    <InfoBox>L&#39;esprit des Violons du Roy en un autre temps. Illustration de Jean-Philippe Le Bas, Le maître de danse, 1745.</InfoBox>
                </div>
            </div>
        </div>
        </SidebarLeft>
        <Container>
            <TitreAxe>Monuments</TitreAxe>
            <SvgCollectif/>
            <h1>Violons du Roy</h1>
            <p>Réunis pour la première fois en 1984, les Violons du Roy ont fait leur marque par la maîtrise du répertoire baroque. Multipliant les collaborations internationales, profitant d'une résidence permanente au Palais Montcalm, ils sont devenus une institution culturelle de la capitale. Porté par un double intérêt pour la mémoire et l'utopie, la réalisation de Ludovica s'est approchée de l'ensemble avec une perspective dialectique: histoire et esthétique.</p>
            <a href="http://violonsduroy.com/">violonsduroy.com</a>
            <FragAxe2/>
        </Container>
        <SidebarRight>
            <BtnCapsuleViolons/>
            <BtnLePalaisMontcalm/>
            <BtnSymeon/>
            <BtnHenrietteBelley/>
        </SidebarRight>
    </FlexContainer>
        <ImageFooter/>
    </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/collectif-musical-violons-du-roy.js